import ActivityHome from "@/Component/Module/ActivityHome";
import Head from "next/head";
import {
  serverFetchActivityHomePageAdvertisement,
  serverFetchActivityHomePageHeading,
  serverFetchChooseActivities,
  serverFetchCitySpecificExperiences,
  serverFetchCouponList,
  serverFetchFeaturedActivities,
  serverFetchReviewsList,
  serverFetchSeasonalDeals,
} from "@/services/server";
import { getCountryFromContext } from "@/utils/getCountryFromRequest";
import {
  normalizeHomePageAdvertisement,
  normalizeHomePageHeading,
} from "@/utils/homePageHelpers";

export default function Activity({
  initialFeaturedActivities,
  initialCitySpecificExperiences,
  initialChooseActivities,
  initialCouponList,
  initialSeasonalDeals,
  initialReviewsList,
  initialHomePageHeading,
  initialHomePageAdvertisement,
}) {
  return (
    <>
      <Head>
        <title>Next Holidays | Activities</title>
        <meta
          name="description"
          content="Crafted by Experts, Made for You. Search holidays, stays, flights and activities."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, viewport-fit=cover" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ActivityHome
        initialFeaturedActivities={initialFeaturedActivities}
        initialCitySpecificExperiences={initialCitySpecificExperiences}
        initialChooseActivities={initialChooseActivities}
        initialCouponList={initialCouponList}
        initialSeasonalDeals={initialSeasonalDeals}
        initialReviewsList={initialReviewsList}
        initialHomePageHeading={initialHomePageHeading}
        initialHomePageAdvertisement={initialHomePageAdvertisement}
      />
    </>
  );
}

export async function getServerSideProps(context) {
  const country = getCountryFromContext(context);

  try {
    const [
      featuredActivities,
      citySpecificExperiences,
      chooseActivities,
      couponList,
      seasonalDeals,
      reviewsList,
      homePageHeading,
      homePageAdvertisement,
    ] = await Promise.all([
      serverFetchFeaturedActivities(country),
      serverFetchCitySpecificExperiences(country),
      serverFetchChooseActivities(country),
      serverFetchCouponList(country),
      serverFetchSeasonalDeals(country),
      serverFetchReviewsList({ moduleType: "Activity" }, country),
      serverFetchActivityHomePageHeading(country),
      serverFetchActivityHomePageAdvertisement(country).catch(() => null),
    ]);

    return {
      props: {
        initialFeaturedActivities: featuredActivities?.data || null,
        initialCitySpecificExperiences: citySpecificExperiences?.data || null,
        initialChooseActivities: chooseActivities || null,
        initialCouponList: couponList?.data || null,
        initialSeasonalDeals: Array.isArray(seasonalDeals?.data)
          ? seasonalDeals.data
          : [],
        initialReviewsList: reviewsList?.data || null,
        initialHomePageHeading: normalizeHomePageHeading(homePageHeading),
        initialHomePageAdvertisement:
          normalizeHomePageAdvertisement(homePageAdvertisement),
      },
    };
  } catch {
    return {
      props: {
        initialFeaturedActivities: null,
        initialCitySpecificExperiences: null,
        initialChooseActivities: null,
        initialCouponList: null,
        initialSeasonalDeals: [],
        initialReviewsList: null,
        initialHomePageHeading: null,
        initialHomePageAdvertisement: null,
      },
    };
  }
}
